// extracted by mini-css-extract-plugin
module.exports = {"component":"NavigationButton_component__1Tvee","isDisabled":"NavigationButton_isDisabled__RJ-qS","label":"NavigationButton_label__H0-NR","icon":"NavigationButton_icon__z0R41"};